import * as L from 'leaflet'

class WeatherWind extends L.Path {
  private _latlng: L.LatLng
  private _size: number
  private _direction: number
  private _windSymbol: any // ([number, number])[] | ([number, number, number, number])[] | ([number, number, number, number, number, number])[] ;

  constructor(latlng: L.LatLng, options?: WeatherWindOptions) {
    super()
    L.setOptions(this, options)
    this._latlng = L.latLng(latlng)
    this._size = options?.size || 16
    this._direction = ((options?.direction || 0) * Math.PI) / 180
    this._windSymbol = [
      [0.5, 0, -0.5, 0],
      [-0.3, 0.2, -0.5, 0, -0.3, -0.2],
      [0.5, 0, 0.5, -0.2 * 2],
    ]

    options?.speed ||
      (4 > 4 && this._windSymbol.push([0.25, 0, 0.25, -0.2 * 2]))
    options?.speed || (4 > 8 && this._windSymbol.push([0, 0, 0, -0.2 * 1]))

    this.setStroke(options?.stroke || !0)
    this.setColor(options?.color || '#ff0000')
    this.setWeight(options?.weight || 1)
  }

  setColor(color: string): this {
    this.setStyle({ color })
    return this.redraw()
  }

  setFillOpacity(fillOpacity: number): this {
    this.setStyle({ fillOpacity })
    return this.redraw()
  }

  setOpacity(opacity: number): this {
    this.setStyle({ opacity })
    return this.redraw()
  }

  setWeight(weight: number): this {
    this.setStyle({ weight })
    return this.redraw()
  }

  setFill(fill: boolean): this {
    this.setStyle({ fill })
    return this.redraw()
  }

  setStroke(stroke: boolean): this {
    this.setStyle({ stroke })
    return this.redraw()
  }

  setLatLng(latLng: L.LatLng): this {
    const oldLatLng = this._latlng
    this._latlng = latLng
    this.fire('move', { oldLatLng, latlng: this._latlng })
    return this.redraw()
  }

  setDirection(direction: number): this {
    this._direction = direction
    return this.redraw()
  }
  _project() {
    console.log('object')
  }
  _update() {
    this._setPath()
  }
  _setPath() {
    ;(this as any)._path.setAttribute('d', this.getPathString())
  }
  _getLatSize() {
    return this._getLatSizeOf(this._size)
  }
  _getLngSize() {
    return this._getLngSizeOf(this._size)
  }
  _getLatSizeOf(size: number) {
    return (size / 40075017) * 360
  }
  _getLngSizeOf(size: number) {
    return (
      ((size / 40075017) * 360) / Math.cos((Math.PI / 180) * this._latlng.lat)
    )
  }
  getLatLng() {
    return this._latlng
  }
  // 旋转单个数据点
  private rotate(point: [number, number], viewAngle: number): [number, number] {
    const [itemX, itemY] = point
    const sinViewAngle = Math.sin(viewAngle)
    const cosViewAngle = Math.cos(viewAngle)
    return [
      itemX * cosViewAngle - itemY * sinViewAngle,
      itemX * sinViewAngle + itemY * cosViewAngle,
    ]
  }
  // 旋转一组数据点
  private _rotateAllPoints(
    points: [number, number][],
    viewAngle: number
  ): number[] {
    const rotatedPoints: number[] = []
    for (let i = 0; i < points.length; i += 2) {
      // const [itemX, itemY] = points[i]
      const item = (points as any)[i + 0] * this._size
      const nextItem = (points as any)[i + 1] * this._size
      const rotatedPoint = this.rotate([item, nextItem], viewAngle)
      rotatedPoints.push(rotatedPoint[0], rotatedPoint[1])
    }
    return rotatedPoints
  }
  // 将所有点转换到视图坐标系
  private _transformAllPointsToView(points: number[]): number[] {
    const latLngPoint = this._map.latLngToLayerPoint(this._latlng)
    const transformedPoints: number[] = []
    for (let i = 0; i < points.length; i += 2) {
      const x = points[i] + latLngPoint.x
      const y = -points[i + 1] + latLngPoint.y
      transformedPoints.push(x, y)
    }
    return transformedPoints
  }
  // 从点创建路径字符串
  private _createPathFromPoints(points: number[]): string {
    let pathString: string | undefined = `M${points[0]} ${points[1]}`
    for (let i = 2; i < points.length; i += 2) {
      pathString += ` L${points[i]} ${points[i + 1]}`
    }
    return pathString
  }
  // 从模型方向获取视图角度
  private _getViewAngleFromModel(direction: number): number {
    return Math.PI / 2 - direction
  }
  // 调整并移动点大小
  private _resizeAndMovePoint(
    point: [number, number],
    resizeFactor: [number, number],
    offset: [number, number]
  ): [number, number] {
    return [
      point[0] * resizeFactor[0] + offset[0],
      point[1] * resizeFactor[1] + offset[1],
    ]
  }
  private _createWindPathString(): string {
    let pathString = ''
    const viewAngle = this._getViewAngleFromModel(this._direction)
    for (let i = 0; i < this._windSymbol.length; ++i) {
      const rotates = this._transformAllPointsToView(
        this._rotateAllPoints(this._windSymbol[i], viewAngle)
      )
      0 == i
        ? (pathString = this._createPathFromPoints(rotates))
        : (pathString += ` ${this._createPathFromPoints(rotates)}`)
    }
    return pathString
  }
  getPathString(): string {
    return this._createWindPathString()
  }
}

// 定义 WeatherWindOptions 接口
export interface WeatherWindOptions extends L.PathOptions {
  size?: number
  direction?: number
  speed: number
  stroke?: boolean
  color?: string
  weight?: number
  fillColor?: string
}

// 定义 L.weatherWind 工厂函数
function weatherWind(
  latlng: L.LatLng,
  options?: WeatherWindOptions
): WeatherWind {
  return new WeatherWind(latlng, options)
}
export default weatherWind
